import { __assign } from "tslib";
import React from 'react';
import Media from 'react-media';
var PnmacMediaQuery = function (_a) {
  var children = _a.children,
    queries = _a.queries;
  return /*#__PURE__*/React.createElement(Media, {
    queries: __assign({
      small: "(max-width: 599px)",
      medium: "(min-width: 600px) and (max-width: 1199px)",
      mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
      large: "(min-width: 1200px)"
    }, queries)
  }, function (matches) {
    return children(matches);
  });
};
export default PnmacMediaQuery;